var render = function (_h,_vm) {var _c=_vm._c;return _c('GreyPage',[_c('div',{staticClass:"page",style:({ width: _vm.props.width || '910px' })},[_c('BriqPanel',[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }